import React from 'react';
import { Card } from '../components/ui/card';
import { CheckCircle } from 'lucide-react';
import { mockData } from '../data/mockData';

const AboutSection = () => {
  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-blue-900 mb-4">
              {mockData.about.title}
            </h2>
            <div className="w-24 h-1 bg-amber-500 mx-auto mb-6"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              {mockData.about.description}
            </p>
          </div>

          <Card className="p-8 shadow-lg border-l-4 border-amber-500 mb-8">
            <div className="grid md:grid-cols-2 gap-6">
              <div className="flex items-start space-x-3">
                <CheckCircle className="text-green-600 flex-shrink-0 mt-1" size={20} />
                <p className="text-gray-700">
                  Specialized exclusively in trademark registration
                </p>
              </div>
              <div className="flex items-start space-x-3">
                <CheckCircle className="text-green-600 flex-shrink-0 mt-1" size={20} />
                <p className="text-gray-700">
                  Expert knowledge of USPTO procedures
                </p>
              </div>
              <div className="flex items-start space-x-3">
                <CheckCircle className="text-green-600 flex-shrink-0 mt-1" size={20} />
                <p className="text-gray-700">
                  Personalized service with dedicated case managers
                </p>
              </div>
              <div className="flex items-start space-x-3">
                <CheckCircle className="text-green-600 flex-shrink-0 mt-1" size={20} />
                <p className="text-gray-700">
                  98% approval rate on applications
                </p>
              </div>
            </div>
          </Card>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            <img
              src="https://images.unsplash.com/photo-1560250097-0b93528c311a"
              alt="Legal Professional"
              className="rounded-lg shadow-lg object-cover h-48 w-full"
            />
            <img
              src="https://images.unsplash.com/photo-1507679799987-c73779587ccf"
              alt="Business Meeting"
              className="rounded-lg shadow-lg object-cover h-48 w-full"
            />
            <img
              src="https://images.pexels.com/photos/7581115/pexels-photo-7581115.jpeg"
              alt="Legal Documentation"
              className="rounded-lg shadow-lg object-cover h-48 w-full"
            />
            <img
              src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf"
              alt="Professional Team"
              className="rounded-lg shadow-lg object-cover h-48 w-full"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
